import Vue from 'vue';
import config from './api-config';

declare var AppInsightsUtils: any;


export class Services {
    public json(body: any){
        return new Blob(body);
    }

    public async loginUser(username: string, password: string) {
        return await Vue.axios({
            method: 'post',
            url: config.loginUser,
            withCredentials: true,
            data: {
              username,
              password,
            },
          }).then((response) =>{
            if (response.status !== 200) {
                throw Error('Failed - Incorrect Response');
            }

            return response.data;
          });
    }
}

